export default "__VITE_ASSET__ddH0I4sO__"